import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataReadOnlyRow from './EcommDataReadOnlyRow';
import EcommDataNumberRow from './EcommDataNumberRow';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import EcommTableFooter from './EcommTableFooter';

class EcommDataRetouchTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retouchData: {
        ...props.retouchData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      retouchData: {
        ...prevState.retouchData,
        [key]: {
          ...prevState.retouchData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { retouchData } = this.state;
      saveOne({
        date: retouchData[key].date,
        locationType: 'retouch',
        locationId: retouchData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      retouchData: {
        ...prevState.retouchData,
        [key]: {
          ...prevState.retouchData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { retouchData } = this.state;
      saveOne({
        date: retouchData[key].date,
        locationType: 'retouch',
        locationId: retouchData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      })
    });
  };

  getTabIndex = (column)=> {
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { retouchData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      prepItemCount,
      specialProjectOptions,
      canEdit
    } = this.props;
    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="RetouchTitle"
            tableTitle={i18n.t('location:retouchTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(retouchData).map(element =>
                retouchData[element].retouchName)}
            />
            <EcommDataReadOnlyRow
              title={i18n.t('location:items').toUpperCase()}
              valueToDisplay={prepItemCount}
            />
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              key={i18n.t('location:additionalItems').toUpperCase()}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={retouchData}
              rowTitle={i18n.t('location:additionalItems').toUpperCase()}
              valueKey="additionalItems"
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={retouchData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={retouchData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataRetouchTable.propTypes = {
  retouchData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  prepItemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  saveOne: PropTypes.func.isRequired,
  startTabIndex: PropTypes.number,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

EcommDataRetouchTable.defaultProps = {
  startTabIndex: 600
}

export default EcommDataRetouchTable;
